import { TipoMaterialService } from "./../../../services/tipo-material.service";
import { Component, OnInit, AfterContentInit } from "@angular/core";

import {
  FormGroup,
  Validators,
  FormControl,
  FormBuilder,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MaterialService } from "src/app/pages/cadastros/material/material.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { TipoMaterial } from "../../domain/domain.model";
import { APP_SETTINGS, SCAMP_API } from "src/environments/environment";

//material
@Component({
  selector: "app-material",
  templateUrl: "./material.component.html",
  providers: [MaterialService],
})
export class MaterialComponent implements OnInit, AfterContentInit {
  public cadastrados: any[] = [];
  public tiposMateriais: TipoMaterial[] = [];

  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  public autorizacoes: UsuarioAutorizacoes;

  public excelFileName: string = "";
  public hrefExcelFile: string = "";
  public ultimasEntradas: any[] = [];
  public materialSelected: any = {};
  public titleUltimasEntradas: string = `Exibir ${APP_SETTINGS.numeroUltimasEntradasAExibir} últimas entradas`;

  constructor(
    private materialService: MaterialService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private tipoMaterialService: TipoMaterialService
  ) {}

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("material");
  }

  ngOnInit() {
    this.getMateriais(); // carrega lista de já cadastrados
    this.getTiposMateriais();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  public getMateriais(): void {
    this.isProcessing = true;
    this.materialService.getMateriais().subscribe((response: any) => {
      this.cadastrados = response;
      this.setVoids();
      this.isProcessing = false;
    });
  }

  getTiposMateriais() {
    this.tipoMaterialService.getAll().subscribe((response: TipoMaterial[]) => {
      this.tiposMateriais = response;
    });
  }

  public resetForm(): void {
    this.form = this.formBuilder.group({
      id: [0],
      codigo: [null, [Validators.required]],
      ncm: [null],
      descricao: [null, [Validators.required, Validators.maxLength(200)]],
      valor: [0],
      unidade: [null, [Validators.required]],
      tipoMaterialId: [""],
      precoMedio: [0],
      saldo: [0],
      atualizaMaterialValor: APP_SETTINGS.AtualizaMaterialValor,
    });
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;

    this.resetForm();
    this.resetExcel();
  }

  public resetExcel(): void {
    this.excelFileName = "";
    this.hrefExcelFile = "";
  }

  public getById(id: number): void {
    this.reset();
    this.isProcessing = true;

    this.materialService.read(id).subscribe(
      (response: any) => {
        this.form.patchValue({
          id: response.id,
          codigo: response.codigo,
          descricao: response.descricao,
          valor: response.valor ? response.valor : 0,
          unidade: response.unidade,
          precoMedio: response.precoMedio,
          saldo: response.saldo ? response.saldo : 0,
          ncm: response.ncm ? response.ncm : null,
          tipoMaterialId:
            response.tipoMaterialId == null ? "" : response.tipoMaterialId,
        });

        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public async ValidUniqueFields(): Promise<boolean> {
    const { codigo, ncm, descricao, id } = this.form.value;

    let [isUniqueCodigo, isUniqueNCM, isUniqueDescricao] = await Promise.all([
      this.materialService.isUniqueCodigoMaterial(codigo, id).toPromise(),
      this.materialService.isUniqueNCMMaterial(ncm, id).toPromise(),
      this.materialService.isUniqueDescricaoMaterial(descricao, id).toPromise(),
    ]);

    if (isUniqueCodigo == false) {
      this.form.get("codigo").setErrors({ isNotUniqueCodigo: true });
    }

    if (isUniqueNCM == false) {
      this.form.get("ncm").setErrors({ isNotUniqueNCM: true });
    } else {
      if (ncm && ncm.length > 0 && ncm.length !== 8) {
        this.form.get("ncm").setErrors({ isSizeErrorNCM: true });
        isUniqueNCM = false;
      }
    }

    if (isUniqueDescricao == false) {
      this.form.get("descricao").setErrors({ isNotUniqueDescricao: true });
    }

    return isUniqueCodigo && isUniqueNCM && isUniqueDescricao;
  }

  public async submit() {
    const valid_uniqueFields = await this.ValidUniqueFields();

    if (valid_uniqueFields) {
      this.materialService.create(this.form.value).subscribe(
        (response: any) => {
          if (response.data) {
            this.toastr.success(response.message);
            this.reset();
            this.getMateriais();
          } else {
            this.update(this.form.value);
          }
        },
        (error: any) => {
          this.showError(error);
        }
      );
    }
  }

  public update(material: any) {
    this.materialService.create(material).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.getMateriais();
      },
      (error: any) => {
        this.showError(error);
      },
      () => (this.isProcessing = false)
    );
  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) {
        this.voids.push("");
      }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  public delete(id: number, c: any): void {
    this.isProcessing = true;
    c("Close click");

    this.materialService.delete(id).subscribe(
      (response: any) => {
        if (response.success == true) {
          this.toastr.success(response.message);
        } else {
          this.toastr.warning(response.message);
        }

        this.reset();
        this.getMateriais();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {
    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error("Ocorreu um erro no servidor");
    }

    this.isProcessing = false;
  }

  public clearValor() {
    this.form.get("valor").setValue(0);
  }

  public blurValor() {
    if (Number(this.form.get("valor").value) == 0) {
      this.clearValor();
    }
  }

  search(parametro: string) {
    if (parametro === "") {
      return;
    }

    this.resetExcel();

    this.isProcessing = true;

    this.materialService.search(parametro).subscribe((response) => {
      this.cadastrados = response;
      this.setVoids();
      this.isFiltered = true;
      this.isProcessing = false;
    });
  }

  clearSearch() {
    (document.getElementById("parametro") as HTMLInputElement).value = "";
    this.getMateriais();
    this.resetExcel();
    this.isFiltered = false;
  }

  exportarToExcel(parametro: string) {
    this.isProcessing = true;
    this.materialService.exportarToExcel(parametro).subscribe(
      (response) => {
        if (response.success === true) {
          if (response.nenhumResultado === false) {
            this.excelFileName = response.fileName;
            this.hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`;
          } else {
            this.toastr.warning(response.msgErro);
          }
        } else {
          this.toastr.error(response.msgErro);
        }

        this.isProcessing = false;
      },
      (err: any) => {
        this.toastr.error(
          "Ocorreu um erro ao tentar exportar Excel",
          "Erro de Conexão"
        );
        this.isProcessing = false;
      },
      () => (this.isProcessing = false)
    );
  }

  getNextCodigo() {
    this.materialService.getNextId().subscribe((response: any) => {
      this.form.get("codigo").setValue(response.result);
    });
  }

  getUltimasEntradasMaterias(materialId, modal: any) {
    this.materialSelected = this.cadastrados.find((x) => x.id == materialId);

    this.materialService
      .getUltimasEntradasMaterias(materialId)
      .subscribe((response) => {
        this.ultimasEntradas = response;
        this.modalService.open(modal, {
          windowClass: "lgModal",
          backdrop: "static",
        });
      });
  }
}
